export enum PageType {
  Base = "BASE",
  Landing = "LANDING",
}

export enum BasePage {
  Home,
  HotelMap,
  Speakers,
  Sponsors,
}

export const BasePageURL: Record<BasePage, string> = {
  [BasePage.Home]: "",
  [BasePage.HotelMap]: "hotel-map",
  [BasePage.Speakers]: "speakers",
  [BasePage.Sponsors]: "sponsors",
};

export enum SiteBuilderModuleType {
  Accordion = "accordion",
  ButtonGroup = "cta-button-group",
  ColumnText = "column-text",
  CustomForm = "custom-form",
  DropColumn = "drop-column",
  ExhibitorList = "exhibitor-list",
  FileDownload = "file-download",
  Hero = "hero",
  HeroCarousel = "hero-carousel",
  HtmlBlock = "html-block",
  Iframe = "iframe",
  Image = "image",
  ImageGallery = "image-gallery",
  Speakers = "speakers",
  SponsorCategory = "sponsor-category",
  Statistics = "statistics",
  Testimonial = "testimonial",
  TextContent = "text",
  Video = "video",
  VideoGallery = "video-gallery",
}

export enum SiteBuilderModuleVariant {
  OneColumn = "ONE_COLUMN",
  MultiColumn = "MULTI_COLUMNS",
}

export enum SiteBuilderModuleHeaderVariant {
  Variant1 = "VARIANT_1",
  Variant2 = "VARIANT_2",
}

export enum SiteBuilderModuleHeaderPosition {
  Top = "TOP",
  Left = "LEFT",
  Right = "RIGHT",
}

export enum SiteBuilderModuleHeaderAlignment {
  Top = "TOP",
  Middle = "MIDDLE",
}

export enum SiteBuilderModuleTextFieldType {
  Text = "text",
  Header = "header",
}

export enum SiteBuilderModuleLayoutSize {
  Page = "PAGE",
  FullScreen = "FULLSCREEN",
}

export enum SiteBuilderModuleDisplayStyle {
  Standard = "STANDARD",
  Dark = "DARK",
  Light = "LIGHT",
}

export enum SiteBuilderMultiColumnModuleDisplayType {
  Standard = "STANDARD",
  Carousel = "CAROUSEL",
}

export enum SiteBuilderMultiColumnModuleDisplayOrder {
  AsListed = "AS_LISTED",
  Random = "RANDOM",
}

export enum SiteBuilderMultiColumnModuleRotation {
  Static = "STATIC",
  Single = "SINGLE",
  Page = "PAGE",
  Smooth = "SMOOTH",
}
